import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import CSVLink from "../../../useHook/useCSV";
import styles from './table.module.css';

function Table(props) {
    const {headers, title, description, downloadCSV, data} = props;

    const dataCSV = useMemo(() => {
        const list = [];
        const listHeader = headers.map(header => header.name);
        data.forEach((item) => {
            const itemList = []
            headers.forEach((header) => {
                itemList.push(item[header.column]);
            })
            list.push(itemList);
        });
        return [
            [title],
            listHeader,
            ...list,
            [description],
        ];
    }, [data, headers, title, description]);

    return <div className={styles.tableWrapper}>
        <table>
            <thead>
                <tr className={styles.headerWrapper}>
                    {headers.map((item, idx) => <th key={idx}>
                        <span>{item.name}</span>
                    </th>)}
                </tr>
            </thead>
            <tbody>
                {data.map((item, idx) => {
                    return <tr key={idx} className={styles.bodyWrapper}>
                        {headers.map((header, index) => <td key={index}>
                            {item[header.column] != null && item[header.column]}
                        </td>)}
                    </tr>
                })}
            </tbody>
        </table>
        <CSVLink data={dataCSV} autoDownload={downloadCSV} filename={'player-topic-table-'+ title +'.csv'} />
    </div>
}

Table.propTypes = {
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    downloadCSV: PropTypes.bool,
};

export default Table;
